import { combineReducers } from 'redux';

import chatsMessage from './chatsMessage';
import sendChat from './sendChat';
import pubnub from './pubnub';
import rejectTutor from './rejectTutor';
import selectQuestion from './selectQuestion';
import startSession from './startSession';
import endSession from './endSession';
import cancelQuestion from './cancelQuestion';
import tutorStatics from './tutorStatic';
import images from './images';
import answerStage from './answerStage';
import chatAlertBanner from './chatAlertBanner';
import chatModal from './chatModal';
import tagging from './tagging';
import sidebar from './sidebar';

const reducer = combineReducers({
  chatsMessage,
  selectQuestion,
  sendChat,
  pubnub,
  rejectTutor,
  startSession,
  endSession,
  cancelQuestion,
  tutorStatics,
  images,
  answerStage,
  chatAlertBanner,
  chatModal,
  tagging,
  sidebar,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/index.js